export const INVITE_TOKEN_KEY = "track.inviteToken";

export function storeInviteToken(token: string) {
  sessionStorage.setItem(INVITE_TOKEN_KEY, token);
}

export function readInviteToken(): string | null {
  return sessionStorage.getItem(INVITE_TOKEN_KEY);
}

export function clearInviteToken() {
  sessionStorage.removeItem(INVITE_TOKEN_KEY);
}
